export default __webpack_public_path__ + "static/media/enviar-dinero.d74cd102.png";